export enum VehiclePriceTypeIdEnum {
  ZeroKm,
  Dealer,
  Private,
  TradeIn,
}
